import { render } from "./adminCreationSuccess.vue?vue&type=template&id=5de4b6f2&scoped=true"
import script from "./adminCreationSuccess.vue?vue&type=script&lang=js"
export * from "./adminCreationSuccess.vue?vue&type=script&lang=js"

import "./adminCreationSuccess.vue?vue&type=style&index=0&id=5de4b6f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de4b6f2"]])

export default __exports__